import React from "react";
import { Box, Typography, Paper, Chip, Divider, CircularProgress, Button } from "@material-ui/core";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ChatIcon from "@material-ui/icons/Chat";
import EditIcon from "@material-ui/icons/Edit";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import PersonIcon from "@material-ui/icons/Person";
import moment from "moment";
import { D11 } from "./contact360.constants";
import { textOrEmpty } from "./contact360.helpers";

// D8.4.4b — Tab "Historial" (timeline; presentacional, recibe data por props).

export default function Contact360HistorialTab({
  classes,
  loading,
  loadingMore,
  events,
  iaHints,
  total,
  timelineRestrictedMsg,
  onLoadMore
}) {
  const hasMore = events.length < total;

  return (
    <Box mt={2}>
      <Paper className={classes.bannerIa} elevation={0} style={{ marginBottom: 12 }}>
        <Typography variant="body2">
          Línea de tiempo operativa del contacto: alta en CRM, conversaciones registradas como tickets y citas (según
          permisos de agenda). Sugerencias IA del perfil se listan aparte cuando existen datos.
        </Typography>
      </Paper>

      {timelineRestrictedMsg && (
        <Paper variant="outlined" style={{ padding: 12, marginBottom: 12, borderColor: D11.orange }}>
          <Typography variant="body2">{timelineRestrictedMsg}</Typography>
          <Typography variant="caption" display="block" style={{ color: D11.placeholder, marginTop: 6 }}>
            Los eventos de citas no se incluyen en esta vista para tu usuario; verás alta de contacto y tickets si
            aplica.
          </Typography>
        </Paper>
      )}

      {Array.isArray(iaHints) && iaHints.length > 0 ? (
        <Box mb={2}>
          <Typography variant="subtitle2" style={{ fontWeight: 700, letterSpacing: 0.6, color: D11.green, marginBottom: 8 }}>
            SUGERENCIAS IA (PERFIL)
          </Typography>
          <Box display="flex" flexWrap="wrap" style={{ gap: 6 }}>
            {iaHints.map((h, idx) => (
              <Chip
                key={`${h.fieldKey}-${idx}`}
                size="small"
                label={(() => {
                  if (typeof h.confidence !== "number" || Number.isNaN(h.confidence)) return h.label;
                  const pct = h.confidence <= 1 && h.confidence >= 0 ? Math.round(h.confidence * 100) : Math.round(h.confidence);
                  return `${h.label} · IA ${pct}%`;
                })()}
                style={{
                  borderLeft: `3px solid ${D11.green}`,
                  backgroundColor: "rgba(0, 200, 83, 0.08)"
                }}
              />
            ))}
          </Box>
        </Box>
      ) : null}

      <Divider style={{ margin: "16px 0" }} />

      <Typography variant="subtitle2" style={{ fontWeight: 700, letterSpacing: 0.6, color: D11.blue, marginBottom: 8 }}>
        ACTIVIDAD
      </Typography>

      {loading && events.length === 0 ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress size={36} />
        </Box>
      ) : events.length === 0 ? (
        <Typography variant="body2" style={{ fontStyle: "italic", color: D11.placeholder }}>
          Sin eventos registrados para este contacto.
        </Typography>
      ) : (
        events.map((ev, idx) => {
          const Icon =
            ev.kind === "appointment"     ? CalendarTodayIcon
            : ev.kind === "ticket"        ? ChatIcon
            : ev.kind === "contact_updated" ? EditIcon
            : ev.kind === "remarketing_sim" ? WatchLaterIcon
            : PersonIcon;
          const borderLeft =
            ev.kind === "appointment"     ? `3px solid ${D11.green}`
            : ev.kind === "ticket"        ? "3px solid #5c6bc0"
            : ev.kind === "contact_updated" ? "3px solid #FF9800"
            : ev.kind === "remarketing_sim" ? "3px solid #00897b"
            : `3px solid ${D11.blue}`;
          const when = moment(ev.occurredAt).format("DD/MM/YYYY HH:mm");
          const detailSafe = typeof ev.detail === "string" ? ev.detail : "";

          return (
            <Paper
              key={`${ev.kind}-${ev.refId ?? "na"}-${ev.occurredAt}-${idx}`}
              variant="outlined"
              elevation={0}
              className={classes.timelineEvent}
              style={{ borderLeft }}
            >
              <Box display="flex" alignItems="flex-start" style={{ gap: 10 }}>
                <Icon style={{ fontSize: 22, marginTop: 2, color: D11.placeholder }} />
                <Box flex={1} minWidth={0}>
                  <Typography className={classes.timelineDate}>{when}</Typography>
                  <Typography variant="subtitle2" style={{ fontWeight: 700, color: D11.blue }}>
                    {textOrEmpty(ev.title) || ev.kind || "—"}
                  </Typography>
                  {detailSafe ? (
                    <Typography variant="body2" style={{ marginTop: 4, color: "#424242", wordBreak: "break-word" }}>
                      {detailSafe}
                    </Typography>
                  ) : null}
                  {typeof ev.refId === "number" ? (
                    <Typography variant="caption" style={{ color: D11.placeholder }}>
                      Ref. #{ev.refId}
                    </Typography>
                  ) : null}
                </Box>
              </Box>
            </Paper>
          );
        })
      )}

      {hasMore ? (
        <Box mt={2} display="flex" justifyContent="center">
          <Button variant="outlined" color="primary" size="small" disabled={loadingMore} onClick={onLoadMore}>
            {loadingMore ? <CircularProgress size={22} /> : "Cargar más"}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
}
